import { profileHash } from "PFCore/helpers/profile_hash";

export const filterForBlindSelection = ([headers, items]) => {
  const hiddenColumnsIndexes = ["Profinda ID", "Email", "Last Name", "Phone", "Website"]
    .map((column) => headers.indexOf(column))
    .sort()
    .reverse();

  const filteredHeaders = headers.filter((item, i) => !hiddenColumnsIndexes.includes(i));

  const firstNameIndex = headers.indexOf("First Name");
  const idIndex = headers.indexOf("Profinda ID");

  const filteredAndUnbiasedItems = items.map((item) => {
    item.splice(firstNameIndex, 1, `Candidate ${profileHash(item[idIndex])}`);
    return item.filter((item, i) => !hiddenColumnsIndexes.includes(i));
  });

  return [filteredHeaders, filteredAndUnbiasedItems];
};
